<template>
  <div>
    <mainHeader></mainHeader>
    <testPortalBanner v-if="isTestPortal"></testPortalBanner>
    <sideMenu :studyData="studyData" :isTestPortal="isTestPortal"></sideMenu>
    <div class="has-sidemenu has-header" :class="{ 'test-portal-padding-reset': isTestPortal }">
      <navBar v-if="isDetailPage" :routes="navBarRoutes" />
      <router-view :studyData="studyData" :studyId="studyId"></router-view>
    </div>
  </div>
</template>

<script>
import mainHeader from "@/components/common/main-header";
import sideMenu from "@/components/common/side-menu";
import navBar from "@/components/common/nav-bar";
import testPortalBanner from "@/components/common/test-portal-banner";
import localStorageService from "@/services/localStorage";
import { TEST_PORTAL_SUFFIX } from "../constants/config";
import { CRA, CraUB } from "@/constants/authRoles";
import { mapGetters } from "vuex";

export default {
  name: "research-team",
  components: {
    mainHeader,
    sideMenu,
    navBar,
    testPortalBanner
  },
  data() {
    return {
      studyData: {}
    };
  },
  computed: {
    ...mapGetters(["user"]),
    studyId() {
      return this.$route.params.studyId;
    },
    isDetailPage() {
      let noTabPages = ["study-admins", "study-team", "research-site", "list-research-site", "add-research-site", "research-site-details", "add-research-site-documents"];

      if (this.isTestPortal) {
        noTabPages = noTabPages.map(page => `${TEST_PORTAL_SUFFIX}${page}`);
      }

      return noTabPages.includes(this.$route.name);
    },
    navBarRoutes() {
      const routes = [];
      if (![CRA, CraUB].includes(this.user.userRole)) {
        routes.push({
          label: "Admin",
          to: {
            name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}study-admins`,
            params: { studyId: this.studyId }
          }
        });
        routes.push({
          label: "Study Team",
          to: {
            name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}study-team`,
            params: { studyId: this.studyId }
          }
        });
      }
      routes.push({
        label: "Research Sites",
        to: {
          name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}list-research-site`,
          params: { studyId: this.studyId }
        }
      });
      return routes;
    }
  },
  mounted() {
    try {
      this.studyData = localStorageService.getItem("studyDetailsData")[this.studyId] || {};
    } catch (e) {
      console.error(e);
      this.studyData = {};
    }
  },
  props: {
    isTestPortal: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.nav-bar .nav-link.active {
  margin-left: 35px !important;
  margin-right: 30px !important;
  padding-left: 2px !important;
  padding-right: 2px !important;
  color: #2d3752 !important;
  font-weight: bold;
}

.nav-bar .nav-link {
  margin-left: 35px !important;
  margin-right: 30px !important;
  padding-left: 2px !important;
  padding-right: 2px !important;
  color: #2d3752 !important;
}
</style>
